/** Coerce an untrusted value (a `/v2/userSettings` blob entry, or a cross-tab broadcast payload)
 *  to one of a known set of string presets, falling back to `fallback` for anything else. The
 *  `typeof v === 'string'` guard plus an explicit whitelist means inherited Object.prototype keys
 *  ('toString'/'constructor') and non-string junk can never be mistaken for a valid preset.
 *
 *  Single source of truth for every `display.*` preference coercer (number format, date format,
 *  time format, first-day-of-week) so the hardening can't drift between them — previously each was
 *  a hand-rolled `=== 'a' || === 'b'` chain (date prefs) or a bespoke hasOwnProperty check (number
 *  pref), and only one of them was prototype-safe. */
export function coercePref<T extends string>(v: unknown, valid: readonly T[], fallback: T): T {
  return typeof v === 'string' && (valid as readonly string[]).includes(v) ? (v as T) : fallback;
}
